import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    error: '',
    violations: null,
    isLoading: false,
    items: null,
    isLoadingAll: false,
    allItems: null
  },
  actions,
  getters,
  mutations
}
